import React from "react";
import tw from "twin.macro";
import styled, { css } from "styled-components";
import { css as cssMacro } from "styled-components/macro"; //eslint-disable-line

const Container = tw.div`relative -mx-8 -mt-8 font-work_sans`;
const TwoColumn = tw.div`flex flex-col lg:flex-row bg-secondary-500 text-gray-900 min-h-screen`;

/* 手机端填满 + 垂直居中；PC 严格 1/2 */
const LeftColumn = tw.div`px-8 xl:pl-10 pt-6 pb-10 lg:w-1/2 flex flex-col justify-center min-h-[50vh] lg:min-h-0`;

/* 右侧：视频容器（不可点击） */
const RightColumn = styled.div`
    ${tw`w-full`}
    position: relative;
    flex: 1 1 auto;
    width: 100%;
    min-height: 50vh;         /* 移动端有高度 */
    @media (min-width: 1024px) {
        flex: none;
        width: 50%;             /* PC 严格 1/2 */
        min-height: 60vh;       /* 给视频一个稳定高度，你也可改成 100vh */
    }
    background: #0b1f3a;      /* 视频加载前的底色 */
`;

/* 覆盖铺满的视频 */
const VideoBg = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;         /* 像 background-size: cover */
  pointer-events: none;      /* 不可点击/不可交互 */
`;

/* 内容区 */
const Content = tw.div`mt-2 lg:mt-4 mb-6 flex flex-col items-start text-left`;

/* 标题更紧凑 */
const Heading = styled.h1`
  ${tw`tracking-tight`}
  font-size: clamp(1.78rem, 1.18rem + 2.6vw, 2.85rem);
    line-height: 1;
    font-size: 2.6rem;
  @media (min-width: 768px) { line-height: 0.98; }
`;

/* 段落放大；“Prefer coffee?” 单独一行：加粗 + 下划线；下方接续文案另起一行并加间距 */
const Paragraph = styled.p`
  ${tw`my-6 lg:my-12 leading-snug`}
  max-width: 42rem;                 /* 稍放宽 */
  font-size: clamp(1.05rem, 0.9rem + 0.6vw, 1.25rem);

  .coffee {
    display: block;
    margin-top: 36px;
    font-weight: 600;               /* 黑体效果 */
    text-decoration: underline;
    text-underline-offset: 4px;
    text-decoration-thickness: 2px;
  }

  .after {
    display: block;
    margin-top: 8px;                /* 与“Prefer coffee?” 的间距 */
  }
`;

export default ({
                    heading = (
                        <>
                            <span>YOUR DAILY</span>
                            <br />
                            <span>RITUAL:</span>
                            <br />
                            <span>CEREMONIAL </span>
                            <br />
                            <span>MATCHA &</span> <br />
                            <span>ORGANIC COFFEE</span>
                        </>
                    ),
                    description = (
                        <>
                            At the Grain Matcha Bar, every cup starts with Uji ceremonial grade matcha, whisked by hand for clean, lasting energy.
                            <span className="coffee">Prefer coffee?</span>
                            <span className="after">We serve only organic beans, brewed fresh. Real drinks, real integrity.</span>
                        </>
                    ),
                    videoSrc = "https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/199_1759887228.mp4",
                }) => {
    return (
        <Container>
            <TwoColumn>
                <LeftColumn>
                    <Content>
                        <Heading>{heading}</Heading>
                        <Paragraph>{description}</Paragraph>
                    </Content>
                </LeftColumn>

                <RightColumn aria-label="Hero video">
                    <VideoBg
                        src={videoSrc}
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="auto"
                        controls={false}
                        aria-hidden="true"
                    />
                </RightColumn>
            </TwoColumn>
        </Container>
    );
};
